export const SHOW_MODAL_REGISTRATION_BUSINESS =
  'SHOW_MODAL_REGISTRATION_BUSINESS';
export const SHOW_OTP_REGISTRATION_BUSINESS = 'SHOW_OTP_REGISTRATION_BUSINESS';
export const RESET_CAPTCHA_REGISTRATION = 'RESET_CAPTCHA_REGISTRATION';
export const SET_OTP_REQUEST_ID = 'SET_OTP_REQUEST_ID';
export const VERIFY_OTP = 'VERIFY_OTP';
export const SET_USER_FORM = 'SET_USER_FORM';
export const OTP_ERROR = 'OTP_ERROR';
export const ON_CLICK_CHANGE_EMAIL_REGISTRATION =
  'ON_CLICK_CHANGE_EMAIL_REGISTRATION';
